import { Component, ElementRef, HostListener, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { AnimationEvent } from '@angular/animations';

import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { PopupTooltipCloseEventType, PopupTooltipRef } from '../cog/popup-tooltip-ref';
import { popupTooltipAnimations, PopupTooltipAnimationState } from './popup-tooltip-animations';

@Component({
    selector: '',
    template: '',
    styleUrls: [],
    animations: [
        popupTooltipAnimations.toggleTooltip
    ],
    standalone: false
})
export class PopupTooltipBaseComponent<P> implements AfterViewInit, OnDestroy
{
    @Input() parameters: P;
    public animationState: PopupTooltipAnimationState = 'hide';
    /**
     * ! Largeur en vw et non en px
     */
    public width: number;
    public height: number;
    protected destroyator = new Subject();
    private intervalId: NodeJS.Timeout;
    private intervalDuration: number = 3000;
    private closeEventType: PopupTooltipCloseEventType = PopupTooltipCloseEventType.Outside;
    private firstOpen: boolean;
    get origin (): HTMLElement
    {
        return this.host.nativeElement;
    }

    constructor (
        private host: ElementRef<HTMLElement>,
        protected popupTooltipRef: PopupTooltipRef
    )
    {
        this.width = this.popupTooltipRef.config.width;
        this.height = this.popupTooltipRef.config.height;
        this.firstOpen = true;
    }

    ngAfterViewInit (): void
    {
        this.overlayClickOutside()
            .subscribe(
                (): void =>
                    this.onClickOutside()
            );
        this.animationState = 'show';
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    @HostListener('mouseout') waitForClosing ():void
    {
        // this.intervalId = setTimeout(() => this.onTimeout(), this.intervalDuration);
    }

    @HostListener('mouseover') stopWaitingForClosing ():void
    {
        clearTimeout(this.intervalId);
    }

    protected onTimeout (): void
    {
        this.closeEventType = PopupTooltipCloseEventType.TimeOut;
        this.animationState = 'hide';
    }

    protected onClicked (): void
    {
        this.closeEventType = PopupTooltipCloseEventType.Clicked;
        this.animationState = 'hide';
    }

    public onClickOutside (): void
    {
        if (this.firstOpen)
        {
            this.firstOpen = false;
        }
        else
        {
            if (this.animationState === 'show')
            {
                this.closeEventType = PopupTooltipCloseEventType.Outside;
                this.animationState = 'hide';
            }
        }
    }

    private closeRef (popupTooltipCloseEventType: PopupTooltipCloseEventType): void
    {
        this.popupTooltipRef.close(popupTooltipCloseEventType);
    }

    public onToggleTooltip (event: AnimationEvent): void
    {
        const { phaseName, fromState, toState } = event;

        if (toState === 'show' && phaseName === 'done')
        {
            // this.intervalId = setTimeout(() => this.onTimeout(), this.intervalDuration);
        }

        if (fromState === 'show' && toState === 'hide' && phaseName === 'done')
        {
            clearTimeout(this.intervalId);
            this.closeRef(this.closeEventType);
        }
    }

    private overlayClickOutside = () =>
    {
        return fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter((event: MouseEvent) =>
                {
                    const clickTarget = event.target as HTMLElement;
                    const notOrigin = clickTarget !== this.origin;
                    const notOverlay = this.popupTooltipRef.overlayRef && (this.popupTooltipRef.overlayRef.overlayElement.contains(clickTarget) === false);

                    return notOrigin && notOverlay;
                }),
                takeUntil(this.popupTooltipRef.overlayRef.detachments())
            );
    };
}
